import type {
	SummaryRequest,
	CustomSummaryResponse,
	SummarySubmissionResponse,
} from '../../../summary/types.tsx';
import poll from '../poll/index.tsx';
import submitTask from '../submit-task/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (request: SummaryRequest): Promise<CustomSummaryResponse> =>
	submitTask(request).then((response: SummarySubmissionResponse) =>
		poll(response.taskId, request).then((result: CustomSummaryResponse) =>
			Promise.resolve({ ...result, taskId: response.taskId }),
		),
	);
